import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ipm-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() isShowBeatLoading: boolean = false;
  @Input() type: string = "";
  constructor() { }

  ngOnInit(): void {
  }

}
